import React, { useMemo, useState } from 'react';

import CloseIcon from '@mui/icons-material/Close';
import { Typography } from '@mui/material';

import { checkRole } from '@common/components/RBAC';
import { useStore } from '@common/components/StoreProvider';
import ChatStudentModalContent from '@common/modules/Chat/Title/Rules/StudentModalContent';
import ChatTeacherModalContent from '@common/modules/Chat/Title/Rules/TeacherModalContent';

import { useConfig } from '../../config';
import { getChatRulesDetails } from '../../config/ChatRules';
import { useTranslationContext } from '../../context';
import * as Styled from './styled';

function ChatRules() {
	const { t } = useTranslationContext();
	const store = useStore();
	const details = useConfig(getChatRulesDetails);
	const isStudent = checkRole('Student');

	const isShowingModalFirstTime = !store.profile?.chatRulesAcceptances.get(
		`${details?.serviceId}-${details?.businessUnitId}`,
	);

	const [isOpen, setIsOpen] = useState(isShowingModalFirstTime);

	const handleOpenModal = () => {
		setIsOpen(true);
	};

	const handleCloseModal = () => {
		setIsOpen(false);

		isShowingModalFirstTime &&
			store.profile.updateChatRuleSeenStatus({
				service_id: details.serviceId,
				business_id: details.businessUnitId,
			});
	};

	const ChatModalContentComponent = useMemo(
		() => (isStudent ? ChatStudentModalContent : ChatTeacherModalContent),
		[isStudent],
	);

	return (
		<>
			<Styled.InfoIcon onClick={handleOpenModal} />
			<Styled.RuleModal open={isOpen} isStudent={isStudent}>
				<Styled.Header>
					<Typography variant="h2">{t('common.chat.rules')}</Typography>
					<Styled.CloseWrap onClick={handleCloseModal}>
						<CloseIcon color="primary" />
					</Styled.CloseWrap>
				</Styled.Header>
				<ChatModalContentComponent onClose={handleCloseModal} />
			</Styled.RuleModal>
		</>
	);
}

export default ChatRules;
